import graphql__21383ef5cd53ec04f4bb from "./__generated__/EmailLayoutsViewEmailLayoutsQuery.graphql.ts";import * as React from "react";
import {useState} from "react";
import Panel from "./presentational/Panel";
import {usePreloadedQuery} from "react-relay/hooks";
import {graphql} from "react-relay";
import Headline from "./presentational/Headline";
import {faPlusCircle} from "@fortawesome/pro-regular-svg-icons";
import ActionButton from "./presentational/button/ActionButton";
import {useOutletContext} from "react-router";
import {useIntl} from "react-intl";
import EmailLayoutList from "./EmailLayoutList";
import CreateEmailLayoutDialog from "./dialog/CreateEmailLayoutDialog";
import type {EmailLayoutsViewEmailLayoutsQuery as EmailLayoutsViewEmailLayoutsQueryType} from "./__generated__/EmailLayoutsViewEmailLayoutsQuery.graphql";

const EmailLayoutsView: React.FC = () => {
    const intl = useIntl();
    const prepared: any = useOutletContext();
    const [showCreateDialog, setShowCreateDialog] = useState(false);

    const query = usePreloadedQuery<EmailLayoutsViewEmailLayoutsQueryType>(
        graphql__21383ef5cd53ec04f4bb,
        prepared?.emailLayoutsQuery,
    );

    // Check if the preloaded query is available
    if (!prepared || !prepared.emailLayoutsQuery) {
        return (
            <Panel>
                <div className="px-6 pt-6 pb-4">
                    <div className="md:flex md:items-center md:justify-between">
                        <div className="flex-1 min-w-0">
                            <Headline>{intl.formatMessage({id: 'view.emailLayouts.headline'})}</Headline>
                        </div>
                    </div>
                </div>
                <div className="text-center py-10">
                    <p className="text-gray-500">{intl.formatMessage({id: 'common.loading'})}</p>
                </div>
            </Panel>
        );
    }

    return (
        <>
            <Panel>
                <div className="px-6 pt-6 pb-4">
                    <div className="md:flex md:items-center md:justify-between">
                        <div className="flex-1 min-w-0">
                            <Headline>{intl.formatMessage({id: 'view.emailLayouts.headline'})}</Headline>
                        </div>
                        <div className="mt-6 flex space-x-3 md:mt-0 md:ml-4">
                            <ActionButton
                                icon={faPlusCircle}
                                title={intl.formatMessage({id: 'view.emailLayouts.createLayout'})}
                                onClick={() => setShowCreateDialog(true)}
                            />
                        </div>
                    </div>
                </div>
                <EmailLayoutList queryRef={query}/>
            </Panel>

            {showCreateDialog && (
                <CreateEmailLayoutDialog
                    onClose={() => setShowCreateDialog(false)}
                />
            )}
        </>
    );
}

export default EmailLayoutsView;
